var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.0957H11.5V7.0957H9.5V5.0957ZM9.5 9.0957H11.5V15.0957H9.5V9.0957ZM10.5 0.0957031C4.98 0.0957031 0.5 4.5757 0.5 10.0957C0.5 15.6157 4.98 20.0957 10.5 20.0957C16.02 20.0957 20.5 15.6157 20.5 10.0957C20.5 4.5757 16.02 0.0957031 10.5 0.0957031ZM10.5 18.0957C6.09 18.0957 2.5 14.5057 2.5 10.0957C2.5 5.6857 6.09 2.0957 10.5 2.0957C14.91 2.0957 18.5 5.6857 18.5 10.0957C18.5 14.5057 14.91 18.0957 10.5 18.0957Z",
    fill: "#F2464B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTick);
export default __webpack_public_path__ + "static/media/red-tick.70ad124792c8c7b4d636ad3402e32113.svg";
export { ForwardRef as ReactComponent };